import { render, staticRenderFns } from "./add_material.vue?vue&type=template&id=dc216162&scoped=true&"
import script from "./add_material.vue?vue&type=script&lang=js&"
export * from "./add_material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc216162",
  null
  
)

export default component.exports